<template>
  <div>
    <div style="display: flex;">
        <h2 style="width: 80%;">My Financial Transactions</h2>
      <div v-if="this.isSuperUserAdmin" style="align-self: center;">
        <ejs-dropdownbutton :items='invoiceItems'  cssClass='e-info btn-ddl' iconCss='fas plus'
          :select="onAddInvoiceClick">Add New Invoice</ejs-dropdownbutton>
      </div>
    </div>
    <div class="e-card" v-if="this.isSuperUserAdmin">
      <div class="e-card-content" style="display: flex">
        <ejs-autocomplete
          ref="autocompleteUsersRef"
          :dataSource="invoiceOwners"
          placeholder="Select user profile..."
          :fields="{ value: 'userFullInfo' }"
          minLength="3"
          sortOrder="Ascending"
          filterType="Contains"
          float-label-type="Always"
          :change="onUserSelection"
          cssClass="e-static-clear"
          :value="userFullInfo"
        />
      </div>
    </div>

    <div style="margin-top: 5px" id="openInvoicesTarget" class="e-card">
      <div class="e-card-title">My Open Invoices</div>
      <div class="e-card-separator"></div>
      <div class="e-card-content">
        <ejs-grid
          ref="gridMyOpenInvoicesRef"
          :dataSource="myOpenInvoices"
          :toolbar="toolbarOptions"
          :created="gridOpenInvoicesCreated"
          :commandClick="onCmdClick"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :allowTextWrap="true"
          :textWrapSettings="wrapSettings"
          :rowDataBound="rowInvoiceDataBound"
        >
          <e-columns>
            <e-column
              headerText="Add to Cart"
              :commands="commands2"
              textAlign="Left"
              width="120"
            />

            <e-column headerText="Invoices"
              :commands="commands"
              textAlign="Left"
              width="110"
            />

            <e-column
              field="invoiceNumber"
              headerText="Invoice Number"
              textAlign="Left"
              width="140"
            />
            <e-column
              field="invoiceDate"
              headerText="Invoice Date"
              textAlign="center"
              width="200"
              type="date"
              format="MMM dd, yyyy"
            />
            <e-column
              field="invoiceAmount"
              headerText="Total Amount"
              textAlign="center"
              width="120"
              format="C2"
            />
            <e-column field="invoiceStatus" headerText="Invoice Status" width="160" />
            <e-column
              field="requestType"
              headerText="Application Type"
              textAlign="Left"
              width="250"
            />
            <e-column
              field="applicationRequestRequestId"
              headerText=""
              textAlign="Left"
              width="0"
            />
            <e-column
              field="paymentStatus"
              headerText="Payment Status"
              textAlign="Left"
              width="160"
            />
            <e-column
              field="paymentType"
              headerText="Payment Type"
              textAlign="Left"
              width="140"
            />
            <e-column
              field="paymentMethod"
              headerText="Payment Method"
              textAlign="Left"
              width="140"
            />
            <e-column
              field="siteAddress"
              headerText="Project Location"
              textAlign="Left"
              width="550"
              clipMode="EllipsisWithTooltip"
            />
          </e-columns>
        </ejs-grid>
      </div>
    </div>

    <div style="margin-top: 5px" id="closedInvoicesTarget" class="e-card">
      <div class="e-card-title">My Closed Invoices</div>
      <div class="e-card-separator"></div>
      <div class="e-card-content">
        <ejs-grid
          ref="gridMyClosedInvoicesRef"
          :dataSource="myClosedInvoices"
          :toolbar="toolbarOptions"
          :created="gridClosedInvoicesCreated"
          :commandClick="onClosedCmdClick"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :allowTextWrap="true"
          :textWrapSettings="wrapSettings"
          :queryCellInfo="closedInvoicesQueryCellInfo"
        >
          <e-columns>
            <e-column headerText="Invoices" :commands="commands" textAlign="Left" width="120" />
            <e-column :headerText="actionHeaders.recieptColHeader"
             :commands="commands3" textAlign="Left" width="120" />
            <e-column :headerText="actionHeaders.refundRecieptColHeader"
            :commands="commands4" textAlign="Left" width="120" />
            <e-column
              field="invoiceNumber"
              headerText="Invoice Number"
              textAlign="Left"
              width="120"
            />
            <e-column
              field="invoiceDate"
              headerText="Invoice Date"
              textAlign="center"
              width="200"
              type="date"
              format="MMM dd, yyyy"
            />
            <e-column
              field="invoiceAmount"
              headerText="Invoice Amount"
              textAlign="center"
              width="120"
              format="C2"
            />
            <e-column
              field="refundAmount"
              headerText="Refund Amount"
              textAlign="center"
              width="120"
              format="C2"
            />
            <e-column field="invoiceStatus" headerText="Invoice Status" width="160" />
            <e-column
              field="requestType"
              headerText="Application Type"
              textAlign="Left"
              width="250"
            />
            <e-column
              field="applicationRequestRequestId"
              headerText=""
              textAlign="Left"
              width="0"
            />
            <e-column
              field="paymentStatus"
              headerText="Payment Status"
              textAlign="Left"
              width="160"
            />
            <e-column
              field="paymentType"
              headerText="Payment Type"
              textAlign="Left"
              width="140"
            />
            <e-column
              field="paymentMethod"
              headerText="Payment Method"
              textAlign="Left"
              width="140"
            />
            <e-column
              field="paymentDate"
              headerText="Date Paid"
              textAlign="center"
              width="160"
              type="date"
              format="MMM dd, yyyy"
            />
            <e-column
              field="siteAddress"
              headerText="Project Location"
              textAlign="Left"
              width="550"
              clipMode="EllipsisWithTooltip"
            />
          </e-columns>
        </ejs-grid>
      </div>
    </div>

    <div style="margin-top: 5px" id="target" class="e-card" v-if="existingUserCredits">
      <div class="e-card-title">Credit Available</div>
      <div class="e-card-separator"></div>
      <div class="e-card-content">
        <ejs-grid
          ref="gridMyUserCreditsRef"
          :dataSource="myUserCredits"
          :commandClick="onCmdClick"
          :queryCellInfo="queryStatusCellInfo"
          :allowSorting="true"
        >
          <e-columns>
            <e-column
              field="creditTotalAmount"
              headerText="Credit Limit"
              textAlign="Left"
              width="120"
              format="C2"
            />
            <e-column
              field="creditUsed"
              headerText="Credit Used"
              textAlign="Left"
              width="120"
              format="C2"
            />
            <e-column
              field="creditRemaining"
              headerText="Credit Remaining"
              textAlign="Left"
              width="120"
              format="C2"
            />
            <e-column field="creditActive" headerText="Status" textAlign="Left" width="120" />
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  GridPlugin, CommandColumn, Page, Toolbar, Sort, Search,
} from "@syncfusion/ej2-vue-grids";
import { AutoCompletePlugin } from "@syncfusion/ej2-vue-dropdowns";
import { tokenStorage } from "@/shared/storage-service";
// --import { FETCH_USER_PROFILES } from '@/modules/user-accounts/store';
import { mapActions, mapGetters } from "vuex";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import {
  SET_MY_OPEN_INVOICES,
  SET_MY_CLOSED_INVOICES,
  FETCH_MY_OPEN_INVOICES,
  FETCH_MY_CLOSED_INVOICES,
  FETCH_MY_USERCREDITS,
  SET_MY_USERCREDITS,
  SET_SELECTED_USER,
  FETCH_INVOICE_OWNERS,
} from "../store";
import {
  POST_INVOICE_TO_SHOPPING_CART,
  FETCH_SHOPPING_CART_BY_USER_ID,
} from "../../financials/store";
import { getInvoicePDF, getReceiptPDF } from "../services/reports-api";
// import { getReceiptPDF } from "../services/payment-api";
import { getDocumentFile } from '../../accounting/services/accounting-api';

Vue.use(DropDownButtonPlugin);

Vue.use(AutoCompletePlugin);
Vue.use(GridPlugin);

export default {
  name: "Transactions",
  data() {
    return {
      toolbarOptions: ["Search"],
      actionHeaders: {
        recieptColHeader: "Receipts",
        refundRecieptColHeader: 'Refund Receipts',
      },
      commands: [
        {
          type: "View Invoice",
          buttonOption: {
            cssClass: "e-flat viewpdfbtn",
            iconCss: "e-export-pdf e-icons",
          },
        },
      ],
      commands2: [
        {
          type: "Add To Shopping Cart",
          buttonOption: {
            cssClass: "e-flat",
            iconCss: "shopping-cart e-icons",
          },
        },
      ],
      commands3: [
        {
          type: "View Receipt",
          buttonOption: {
            cssClass: "e-flat viewpdfbtn",
            iconCss: "e-export-pdf e-icons",
          },
        },
      ],
      commands4: [
        {
          type: "Refund Receipt",
          buttonOption: {
            cssClass: "e-flat viewrefundpdfbtn",
            iconCss: "e-export-pdf e-icons",
          },
        },
      ],
      pageSettings: { pageSize: 10 },
      // wrapSettings: { wrapMode: "Header" },
      wrapSettings: { wrapMode: "Both" },
      invoiceItems: [
        {
          id: 'AdditionalInvoice',
          text: 'Add New Permit Fee Invoice',
        },
        {
          id: 'MiscellaneousInvoice',
          text: 'Add New Miscellaneous Invoice',
        },
      ],
    };
  },
  created() {
    this.getInvoiceOwners();
    if (this.loggedUser.id && !this.isSuperUserAdmin) {
      this.loadTransactions(this.loggedUser.id, null, 0, 0);
    }
  },
  destroyed() {
    this.$store.commit(SET_SELECTED_USER, { selectedUser: null });
  },
  computed: {
    ...mapGetters({
      loggedUser: "loggedUser",
      myOpenInvoices: "myOpenInvoices",
      myClosedInvoices: "myClosedInvoices",
      myUserCredits: "myUserCredits",
      selectedUser: "selectedUser",
      shoppingCart: "getShoppingCartByUserId",
      invoiceOwners: "invoiceOwners",
    }),
    isSuperUserAdmin() {
      if (this.loggedUser) {
        const roles = this.loggedUser?.roles.map((x) => x.roleName);
        return (
          roles.includes("Admin") || roles.includes("SuperAdmin") || roles.includes("Accounting")
        );
      }
      return false;
    },
    existingUserCredits() {
      return this.myUserCredits?.length > 0;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    userFullInfo() {
      if (this.selectedUser) {
        // -- load invoice for saved selected user.
        const { userId } = this.selectedUser;
        const { email } = this.selectedUser;
        const { ownerId } = this.selectedUser;
        const { ownerContactId } = this.selectedUser;
        this.loadTransactions(userId, email, ownerId, ownerContactId);
        return this.selectedUser.userFullName
          ? `${this.selectedUser.userFullName} , ${this.selectedUser.email}`
          : this.selectedUser.email;
      }
      if (this.isSuperUserAdmin) {
        this.$store.commit(SET_MY_OPEN_INVOICES, { myOpenInvoices: null });
        this.$store.commit(SET_MY_CLOSED_INVOICES, {
          myClosedInvoices: null,
        });
        this.$store.commit(SET_MY_USERCREDITS, { myUserCredits: null });
        this.$store.commit(SET_SELECTED_USER, { selectedUser: null });
      }
      return null;
    },
  },
  watch: {
    loggedUser() {
      if (this.loggedUser.id && !this.isSuperUserAdmin) {
        this.loadTransactions(this.loggedUser.id, null, 0, 0);
      }
    },
    invoiceOwners(invoiceOwners) {
      if (invoiceOwners) {
        invoiceOwners.forEach((user) => {
          // eslint-disable-next-line no-param-reassign
          user.userFullInfo = user.userFullName
            ? `${user.userFullName} , ${user.email}`
            : user.email;
        });
      }
    },
    selectedUser(val) {
      if (val) {
        const { userId } = val;
        const { email } = val;
        const { ownerId } = val;
        const { ownerContactId } = val;

        // this.userFullInfo = e.itemData.userFullName
        // ? `${e.itemData.userFullName} ${e.itemData.email}` : e.itemData.email;
        this.loadTransactions(userId, email, ownerId, ownerContactId);
        this.$store.commit(SET_SELECTED_USER, { selectedUser: null });
      } else {
        this.$store.commit(SET_MY_OPEN_INVOICES, { myOpenInvoices: null });
        this.$store.commit(SET_MY_CLOSED_INVOICES, {
          myClosedInvoices: null,
        });
        this.$store.commit(SET_MY_USERCREDITS, { myUserCredits: null });
        this.$store.commit(SET_SELECTED_USER, { selectedUser: null });
      }
    },
  },
  methods: {
    ...mapActions({
      getInvoiceOwners: FETCH_INVOICE_OWNERS,
    }),
    // Added clear button and its functionalities to Searchbar
    gridOpenInvoicesCreated() {
      if (this.$refs.gridMyOpenInvoicesRef) {
        const gridMyOpenInvoicesRefSearchEle = document.getElementById(
          `${this.$refs.gridMyOpenInvoicesRef.$el.id}_searchbar`,
        );
        if (gridMyOpenInvoicesRefSearchEle) {
          gridMyOpenInvoicesRefSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.gridMyOpenInvoicesRef.$el.id);
          });
        }
      }
    },
    gridClosedInvoicesCreated() {
      if (this.$refs.gridMyClosedInvoicesRef) {
        const gridMyClosedInvoicesRefSearchEle = document.getElementById(
          `${this.$refs.gridMyClosedInvoicesRef.$el.id}_searchbar`,
        );
        if (gridMyClosedInvoicesRefSearchEle) {
          gridMyClosedInvoicesRefSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.gridMyClosedInvoicesRef.$el.id);
          });
        }
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove("e-search-icon");
      clearBtnEle.classList.add("e-clear-icon");

      clearBtnEle.addEventListener("click", () => {
        e.target.value = "";
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === "") {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async loadTransactions(userId, email, ownerId, ownerContactId) {
      if (!this.isSuperUserAdmin) {
        await this.$store.dispatch(FETCH_SHOPPING_CART_BY_USER_ID, userId);
      }
      await this.$store.dispatch(FETCH_MY_OPEN_INVOICES, {
        userId,
        email,
        ownerId,
        ownerContactId,
      });
      await this.$store.dispatch(FETCH_MY_CLOSED_INVOICES, {
        userId,
        email,
        ownerId,
        ownerContactId,
      });
      if (userId && userId !== "00000000-0000-0000-0000-000000000000") {
        await this.$store.dispatch(FETCH_MY_USERCREDITS, { userId });
      }
    },
    notify(type, message) {
      this.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === "Error" ? "e-toast-danger" : "e-toast-success",
        timeOut: 5000,
      });
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    async onCmdClick(args) {
      const invoice = args.rowData;
      const { invoiceId } = invoice;
      // eslint-disable-next-line default-case
      const accessToken = tokenStorage.getAccessToken();
      const userId = this.loggedUser.id;

      switch (args.commandColumn.type) {
        case "View Invoice":
          // eslint-disable-next-line no-case-declarations
          await getInvoicePDF(accessToken, userId, invoiceId).then((res) => {
            window.location.href = `${res.config.baseURL}${res.config.url}`;
          });
          break;
        case "Add To Shopping Cart":
          if (this.isSuperUserAdmin) {
            const { requestId } = invoice;
            this.$router.push({
              name: "PayByRequest",
              params: { requestId },
            });
          } else {
            let foundInCart = false;
            if (this.shoppingCart !== undefined
        && this.shoppingCart !== null
        && this.shoppingCart.shoppingCartItems !== null
            ) {
              if (
                this.shoppingCart.shoppingCartItems.filter(
                  (item) => item.cartInvoiceId === invoice.invoiceId,
                ).length > 0
              ) {
                foundInCart = true;
              }
            }
            if (foundInCart) {
              this.$router.push("/financials/shopping-cart");
              this.notify("Success", "Invoice already in Shopping Cart, just open to Checkout.");
            } else {
              await this.$store
                .dispatch(POST_INVOICE_TO_SHOPPING_CART, invoiceId)
                .then(() => {
                  this.$router.push("/financials/shopping-cart");
                  this.notify("Success", "Invoice Added to Shopping Cart.");
                })
                .catch((error) => {
                  this.notify("Error", error.response.data.message);
                });
            }
          }
          break;
        default:
          break;
      }
    },

    async onClosedCmdClick(args) {
      const invoice = args.rowData;
      const { invoiceId, orderNumber, refundDocumentId } = invoice;
      const accessToken = tokenStorage.getAccessToken();
      const userId = this.loggedUser.id;
      // eslint-disable-next-line default-case
      switch (args.commandColumn.type) {
        case "View Invoice":
          // eslint-disable-next-line no-case-declarations
          await getInvoicePDF(accessToken, userId, invoiceId).then((res) => {
            window.location.href = `${res.config.baseURL}${res.config.url}`;
          });
          break;
        case "View Receipt":
          // eslint-disable-next-line no-case-declarations
          await getReceiptPDF(accessToken, userId, orderNumber, invoiceId).then((res) => {
            window.location.href = `${res.config.baseURL}${res.config.url}`;
          });
          break;
        case "Refund Receipt":
          if (refundDocumentId) {
            await getDocumentFile(accessToken, userId, refundDocumentId).then((res) => {
              window.location.href = `${res.config.baseURL}${res.config.url}`;
            });
          }
          break;
        default:
          break;
      }
    },
    closedInvoicesQueryCellInfo(args) {
      this.hideRefundReceiptButtonIfNotRefundInvoice(
        args.column?.headerText,
        args.cell,
        args.data,
      );
      this.hideReceiptButtonOnClosedInvoices(
        args.column?.headerText,
        args.cell,
        args.data,
      );
    },
    hideRefundReceiptButtonIfNotRefundInvoice(colHeader, cell, invoice) {
      if (colHeader === this.actionHeaders.refundRecieptColHeader) {
        if (!invoice.refundDocumentId) {
          cell.querySelector('.viewrefundpdfbtn').classList.add('hide');
          // eslint-disable-next-line no-param-reassign
          cell.textContent = 'N/A';
        }
      }
    },
    hideReceiptButtonOnClosedInvoices(colHeader, cell, invoice) {
      if (colHeader === this.actionHeaders.recieptColHeader) {
        if (!invoice.orderNumber || invoice.invoiceStatus.toLowerCase() === 'cancelled' || invoice.invoiceStatus.toLowerCase() === 'cancelled-wo') {
          cell.querySelector('.viewpdfbtn').classList.add('hide');
          // eslint-disable-next-line no-param-reassign
          cell.textContent = 'N/A';
        }
      }
    },

    rowInvoiceDataBound(args) {
      // if (foundInCart || (args.data.paymentStatus !== "Pending Payment"
      // && !args.data.isPaymentTypeReset)
      // || (args.data.isPaymentTypeReset && args.data.paymentType === args.data.userPaymentType)) {
      // ----  paid, or pay by credit cannot add to shopping card.
      if (args.data.paymentStatus === "Paid" || args.data.paymentStatus === "In Progress: Pending Payment") {
        // eslint-disable-next-line no-param-reassign
        args.row
          .querySelectorAll(".e-unboundcelldiv")[0]
          .querySelectorAll("button")[0].style.display = "none";
      }
    },
    // closedRowInvoiceDataBound(args) {
    //   if (args.data.invoiceStatus === 'Cancelled-WO') {
    //     console.log(args.row.querySelectorAll('.e-unboundcelldiv'));
    //     // eslint-disable-next-line no-param-reassign
    //     args.row
    //       .querySelectorAll('.e-unboundcelldiv')[1]
    //       .querySelectorAll('button')[0].style.display = 'none';
    //   }
    // },
    queryStatusCellInfo(args) {
      if (args.column.field === "creditActive") {
        const value = args.data.creditActive;
        if (value) {
          // eslint-disable-next-line no-param-reassign
          args.cell.textContent = "Active";
        } else {
          // eslint-disable-next-line no-param-reassign
          args.cell.textContent = "Inactive";
        }
      }
    },

    async onUserSelection(e) {
      if (e.e) {
        if (e.value) {
          // const { userId } = e.itemData;
          // const { email } = e.itemData;
          // const { ownerId } = e.itemData;
          // const { ownerContactId } = e.itemData;

          // this.userFullInfo = e.itemData.userFullName
          // ? `${e.itemData.userFullName} ${e.itemData.email}` : e.itemData.email;

          await this.$store.commit(SET_SELECTED_USER, { selectedUser: e.itemData });

          // this.loadTransactions(userId, email, ownerId, ownerContactId);
        } else {
          this.$store.commit(SET_MY_OPEN_INVOICES, { myOpenInvoices: null });
          this.$store.commit(SET_MY_CLOSED_INVOICES, {
            myClosedInvoices: null,
          });
          this.$store.commit(SET_MY_USERCREDITS, { myUserCredits: null });
          this.$store.commit(SET_SELECTED_USER, { selectedUser: null });
        }
      }
    },
    onAddInvoiceClick(e) {
      const id = e?.item?.properties?.id;
      // eslint-disable-next-line default-case
      switch (id) {
        case 'AdditionalInvoice':
          this.$router.push(`/accounting/additional-invoice`);
          break;
        case 'MiscellaneousInvoice':
          this.$router.push(`/accounting/miscellaneous-invoice`);
          break;
      }
    },
  },

  provide: {
    grid: [CommandColumn, Page, Toolbar, Sort, Search],
  },
};
</script>

<style>
@import '../../../assets/styles/eservices-base.css';
.container-report {
  padding: 16px 2% 16px 2%;
}
.shopping-cart {
  background: url("../../../assets/cart-plus.svg");
  background-repeat: no-repeat;
  background-size: 25px 25px;
  width: 25px !important;
  height: 25px;
}
.e-card-title {
  background: #0f4b90;
  color: white;
}
.e-btn-icon.e-export-pdf.e-icons {
  color: red;
}
.e-btn-icon.e-excelexport.e-icons.e-icon-left {
  color: green;
}
.hide {
  display: none;
}
</style>
